import { Component, OnInit,Input } from '@angular/core';
import { PM_Itme_Interface } from 'src/app/Interface/PM_Itme_Interface';
import { Empty_PM_Service_Interface, PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_SubmitService } from 'src/app/Service/PM/PM_Submit.service';

@Component({
  selector: 'app-PMSubmitForm',
  templateUrl: './PMSubmitForm.component.html',
  styleUrls: ['./PMSubmitForm.component.scss']
})
export class PMSubmitFormComponent implements OnInit {

  @Input() inner_PM: PM_Service_Interface = Empty_PM_Service_Interface()
  Submit_Dsc: string = ""
  InProccessing:boolean=false
  Done:boolean=false



  constructor(
    private PM_Submit_Service: PM_SubmitService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1163).subscribe(
      data => {
        this.Read_PM_Item()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }


  //#region PM Item

  DataList_PM_Item: Array<PM_Itme_Interface> = []
  Read_PM_Item() {
    this.PM_Submit_Service.GetServiceItem(this.inner_PM.program_id).subscribe(
      data => {
        this.DataList_PM_Item = data
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  item_Data_Change(item: PM_Itme_Interface)
  {
    item.selected=!item.selected
  }

    //#endregion

  SubmitPMForm(datepickerInputServiceDate) {

    var SelectedAll:boolean=true
    var SelectedItem: Array<number> = []
    for (let item of this.DataList_PM_Item)
    {
      for (let item2 of item.detail)
      {
        if (item2.selected)
        {
          SelectedItem.push(item2.id)
        }
        else {
          SelectedAll=false
          this.Alertify_Service.ErrorMessage("گزینه "+item2.title+" بررسی نشده است")
        }
      }
    }

    if (!SelectedAll)
    {

    }
    else if (!this.Submit_Dsc || this.Submit_Dsc.length < 50)
    {
      this.Alertify_Service.ErrorMessage("شرح را وارد نمائید.(حداقل 50 کاراکتر)")
    }
    else {
      this.InProccessing = true
      this.PM_Submit_Service.SubmitService(datepickerInputServiceDate,
        this.Submit_Dsc,
        this.inner_PM.id,
        this.inner_PM.type,
        SelectedItem).subscribe(
          data => {
            this.InProccessing = false
            if (data['id'] == -1)
              this.Alertify_Service.ErrorMessage("تاریخ سرویس باید به تاریخ امروز باشد")
            else if (data['id'] == -2)
              this.Alertify_Service.ErrorMessage("تاریخ سرویس نمی تواند تاریخ آینده باشد")
            else if (data['id'] == -3)
              this.Alertify_Service.ErrorMessage("تاریخ سرویس نمی تواند از 3 روز گذشته تر باشد")
            else if (data['id'] == -4)
              this.Alertify_Service.ErrorMessage("تاریخ سرویس نمی تواند قبل از تاریخ قبلی	سرویس باشد")
            else {
              this.Alertify_Service.SuccessMessage("سرویس ثبت شد")
              this.Done=true
            }

          }
        )
    }

  }

}
